var map = {
	"./color.vue": "dd55",
	"./conditional.vue": "4ca4",
	"./dimension.vue": "1180",
	"./dimensionTable.vue": "89f1",
	"./options.vue": "bb29",
	"./quantity.vue": "d134",
	"./simpleselect.vue": "c219",
	"./stepsItems.vue": "cdc0",
	"./total.vue": "91b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a85a";